import { createFileRoute } from "@tanstack/react-router";
import { PlansPage } from "../../features/billing/plans-page";

export const Route = createFileRoute("/billing/plans")({ component: PlansPage });
